<script>
import {mapActions} from "vuex";

export default {
    name: "AdminCreateItemSmell",
    data() {
        return {
            name: "",
        }
    },
    methods: {
        ...mapActions([
            'saveItemSmell'
        ]),

        createItemSmellSubmit(e) {
            e.preventDefault()
            this.saveItemSmell({
                name: this.name
            })
        }
    }
}
</script>

<template>
  <div class="row">
    <div class="card-body">
      <form class="default-form" @submit="createItemSmellSubmit" novalidate>

        <div class="form-group">
          <label for="nameInput">Naziv</label>
          <input id="nameInput" class="form-control" type="text" placeholder="Naziv mirisa" v-model="name"/>
        </div>

        <button type="submit" class="btn btn-primary">Napravi</button>
      </form>
    </div>
  </div>
</template>

<style scoped>
    .default-form button {
        width: 200px;
        margin-right: 10px;
        margin-bottom: 10px;
    }
</style>
